module.exports = __webpack_public_path__ + "img/192.fixed_soap_dispenser.065cb43a.svg";